export const CURRENCIES = {
  INR: { symbol: '₹', name: 'Indian Rupee', rate: 1, locale: 'en-IN' },
  USD: { symbol: '$', name: 'US Dollar', rate: 84, locale: 'en-US' },
  EUR: { symbol: '€', name: 'Euro', rate: 92, locale: 'de-DE' },
  GBP: { symbol: '£', name: 'British Pound', rate: 107, locale: 'en-GB' },
}

export function formatAmount(inrAmount, currency = 'INR') {
  const curr = CURRENCIES[currency] || CURRENCIES.INR
  const n = Math.round(inrAmount / curr.rate)
  if (currency === 'INR') {
    if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + ' Cr'
    if (n >= 100000) return '₹' + (n / 100000).toFixed(1) + ' L'
    if (n >= 1000) return '₹' + n.toLocaleString('en-IN')
    return '₹' + n
  }
  if (Math.abs(n) >= 1000000) return curr.symbol + (n / 1000000).toFixed(2) + 'M'
  if (Math.abs(n) >= 1000) return curr.symbol + (n / 1000).toFixed(1) + 'K'
  return curr.symbol + n.toLocaleString(curr.locale)
}
